export function isInboxElementVisible(value?: boolean): boolean {
    return value !== false;
}
